// import React, { useState } from "react";
// import {
//   Modal,
//   Button,
//   Form,
//   ListGroup,
//   InputGroup,
//   Spinner,
// } from "react-bootstrap";
// import { IoMdCheckmarkCircleOutline } from "react-icons/io";
// import { Search } from "react-bootstrap-icons";
// import { useQuery, useMutation } from "react-query";
// import api from "../../../../utils/helper";
// import { URLS } from "../../../../utils/URL";
// import { useAlerts } from "../../../../context/AlertContext";

// const ApprovalModal = ({ show, onHide, onApprove, id, courseID }) => {
//   console.log(id, "ivendor id");

//   const { data, isLoading, error } = useQuery(
//     ["vendors", "/super-admin/vendors"],
//     () => {
//       api.get("/super-admin/vendors").then((response) => {
//         return response?.data?.data;
//       });
//       // console.log(users, "ractdata");
//     }
//   );

//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [filteredUsers, setFilteredUser] = useState(
//     // users?.data?.data?.length == 0
//     //   ? []
//     //   : users?.data?.data?.filter((u) => u?.vendor?._id == id)
//     []
//   );

//   console.log(data, "vendordata");

//   console.log(filteredUsers, id, "id--xx");

//   const { showSuccess, showError } = useAlerts();

//   const sendApproval = useMutation(
//     (approval) => api.post("/courses/send-for-approval", approval),
//     {
//       onSuccess: (response) => {
//         console.log(response, "response");
//         showSuccess(response.data?.message || "Approval send successfully!");
//       },
//       onError: (error) => {
//         showError(
//           error.response?.data?.message ||
//             "Failed to send approval. Please try again."
//         );
//       },
//     }
//   );

//   const handleSelectUser = (user) => {
//     setSelectedUser(user._id);
//   };

//   const handleApprove = () => {
//     if (selectedUser) {
//       onApprove(selectedUser);

//       let approvalData = {
//         courseId: courseID,
//         approvalSentTo: [selectedUser],
//       };

//       sendApproval.mutate(approvalData);
//     }
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={onHide}
//       className="assign-teacher-modal"
//       size="md"
//       centered
//     >
//       <Modal.Header className="d-flex flex-column border-none pb-0">
//         <div>
//           <IoMdCheckmarkCircleOutline
//             className="checklogos"
//             color="#039855"
//             size={25}
//           />
//         </div>
//         <Modal.Title className="phoneNumber">Send for Approval</Modal.Title>
//         <p className="linkaccount mb-0">Enter relevant user for approval</p>
//       </Modal.Header>

//       <Modal.Body>
//         <InputGroup className="mb-2">
//           <Form.Control
//             type="search"
//             placeholder="Search"
//             className="searchText"
//             aria-label="Search"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//           <Search className="position-absolute start-0 top-50 translate-middle-y mx-3" />
//         </InputGroup>

//         <ListGroup>
//           {isLoading ? (
//             <Spinner size="sm" />
//           ) : filteredUsers?.length == 0 && !isLoading ? (
//             <p>Vendor Not Found</p>
//           ) : (
//             filteredUsers
//               .filter((user) =>
//                 user?.vendor.name
//                   ?.toLowerCase()
//                   ?.includes(searchTerm?.toLowerCase())
//               )
//               .map((user, index) => (
//                 <ListGroup.Item
//                   key={user.vendor?._id}
//                   action
//                   onClick={() => handleSelectUser(user.vendor)}
//                   className={`d-flex align-items-center border-none justify-content-between
//                                  ${
//                                    ""
//                                    // selectedUser?.id === user.id ? 'active' : ''
//                                  }`}
//                 >
//                   <div className="d-flex align-items-center">
//                     <Form.Check
//                       type="radio"
//                       id={`user-${user?.vendor?._id}`}
//                       checked={selectedUser?._id === user?.vendor?._id}
//                       onChange={() => handleSelectUser(user?.vendor)}
//                       className="me-2"
//                     />
//                     <img
//                       src={URLS.IMG_URL + user?.vendor?.profile_img}
//                       alt={user?.vendor?.name}
//                       className="rounded-circle me-3"
//                       width="40"
//                       height="40"
//                     />
//                     <div className="d-flex flex-column">
//                       <span className="namespan">{user?.vendor?.name}</span>
//                       <span className="font-14 fw-400 text-secondary font-inter">
//                         {user?.vendor?.company}
//                       </span>
//                     </div>
//                   </div>
//                 </ListGroup.Item>
//               ))
//           )}
//         </ListGroup>

//         <div className="d-flex justify-content-between gap-2 mt-4">
//           <Button variant="light" className="btn-sec-v" onClick={onHide}>
//             Cancel
//           </Button>
//           <Button
//             className="btn-sec-v"
//             color="#60B1FF"
//             onClick={handleApprove}
//             disabled={!selectedUser}
//           >
//             {isLoading && <Spinner size="sm" />} Done
//           </Button>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default ApprovalModal;

//--------------------------------------------------------------------------------------------------------------------

import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  ListGroup,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { Search } from "react-bootstrap-icons";
import { useQuery, useMutation } from "react-query";
import api from "../../../../utils/helper";
import { URLS } from "../../../../utils/URL";
import { useAlerts } from "../../../../context/AlertContext";

const ApprovalModal = ({ show, onHide, onApprove, id, courseID }) => {
  console.log(id, "vendor id");

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);

  // Properly handle the API call with React Query
  const {
    data: vendorsData,
    isLoading,
    error,
  } = useQuery(
    ["vendors", "/super-admin/vendors"],
    async () => {
      const response = await api.get("/super-admin/vendors");
      return response?.data?.data || [];
    },
    {
      // Don't retry too many times if the API fails
      retry: 2,
      // Keep data fresh
      refetchOnWindowFocus: false,
      // Handle errors properly
      onError: (err) => {
        console.error("Failed to fetch vendors:", err);
      },
    }
  );

  // Update filtered users when data changes or search term changes
  useEffect(() => {
    if (vendorsData) {
      // Filter by vendor ID and search term
      const filtered = vendorsData
        .filter((user) => user?.vendor?._id === id)
        .filter(
          (user) =>
            !searchTerm ||
            user?.vendor?.name
              ?.toLowerCase()
              ?.includes(searchTerm?.toLowerCase())
        );

      setFilteredUsers(filtered);
    }
  }, [vendorsData, id, searchTerm]);

  const { showSuccess, showError } = useAlerts();

  const sendApproval = useMutation(
    (approval) => api.post("/courses/send-for-approval", approval),
    {
      onSuccess: (response) => {
        showSuccess(response.data?.message || "Approval sent successfully!");
        onHide(); // Close modal on success
      },
      onError: (error) => {
        showError(
          error.response?.data?.message ||
            "Failed to send approval. Please try again."
        );
      },
    }
  );

  const handleSelectUser = (user) => {
    setSelectedUser(user);
  };

  const handleApprove = () => {
    if (selectedUser) {
      const approvalData = {
        courseId: courseID,
        approvalSentTo: [selectedUser._id],
      };

      sendApproval.mutate(approvalData);
      onApprove(selectedUser._id);
    }
  };

  // Render different content based on loading state
  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="text-center py-4">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-2">Loading vendors...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="text-center py-4 text-danger">
          <p>Failed to load vendors. Please try again later.</p>
        </div>
      );
    }

    if (filteredUsers.length === 0) {
      return <p className="text-center py-3">No vendors found for this ID.</p>;
    }

    return (
      <ListGroup>
        {filteredUsers.map((user) => (
          <ListGroup.Item
            key={user.vendor?._id}
            action
            onClick={() => handleSelectUser(user.vendor)}
            className="d-flex align-items-center border-none justify-content-between"
          >
            <div className="d-flex align-items-center">
              <Form.Check
                type="radio"
                id={`user-${user?.vendor?._id}`}
                checked={selectedUser?._id === user?.vendor?._id}
                onChange={() => handleSelectUser(user?.vendor)}
                className="me-2"
              />
              <img
                src={
                  user?.vendor?.profile_img
                    ? URLS.IMG_URL + user?.vendor?.profile_img
                    : "/default-avatar.png"
                }
                alt={user?.vendor?.name || "User"}
                className="rounded-circle me-3"
                width="40"
                height="40"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/default-avatar.png";
                }}
              />
              <div className="d-flex flex-column">
                <span className="namespan">
                  {user?.vendor?.name || "Unknown"}
                </span>
                <span className="font-14 fw-400 text-secondary font-inter">
                  {user?.vendor?.firstname || user?.vendor?.lastname
                    ? `${user?.vendor?.firstname || ""} ${
                        user?.vendor?.lastname || ""
                      }`.trim()
                    : "N/A"}
                </span>
              </div>
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      className="assign-teacher-modal"
      size="md"
      centered
    >
      <Modal.Header className="d-flex flex-column border-none pb-0">
        <div>
          <IoMdCheckmarkCircleOutline
            className="checklogos"
            color="#039855"
            size={25}
          />
        </div>
        <Modal.Title className="phoneNumber">Send for Approval</Modal.Title>
        <p className="linkaccount mb-0">Enter relevant user for approval</p>
      </Modal.Header>

      <Modal.Body>
        <InputGroup className="mb-3">
          <Form.Control
            type="search"
            placeholder="Search"
            className="searchText"
            aria-label="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Search className="position-absolute start-0 top-50 translate-middle-y mx-3" />
        </InputGroup>

        {renderContent()}

        <div className="d-flex justify-content-between gap-2 mt-4">
          <Button variant="light" className="btn-sec-v" onClick={onHide}>
            Cancel
          </Button>
          <Button
            className="btn-sec-v"
            color="#60B1FF"
            onClick={handleApprove}
            disabled={!selectedUser || sendApproval.isLoading}
          >
            {sendApproval.isLoading && <Spinner size="sm" className="me-2" />}
            Done
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ApprovalModal;
